import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalWrapper, Button, TextBox } from '../common';
import { userService } from '../../api/services';

export default function PasswordChangeModal({ onClose, onComplete }) {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState('');
  const [currentPasswordConfirm, setCurrentPasswordConfirm] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const clearError = () => error && setError(false);

  const handleSubmit = async () => {
    if (currentPassword !== currentPasswordConfirm) {
      setError(true);
      return;
    }

    setError(false);
    setSubmitting(true);
    try {
      await userService.changePassword({ current_password: currentPassword, new_password: newPassword });
      onComplete();
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalWrapper onClose={onClose} padding="p-5 sm:p-8" gap="gap-5">
      <h2 className="text-xl font-bold text-mono-900">{t('common.password_change')}</h2>

      <div className="flex flex-col gap-4">
        <TextBox
          label={t('common.current_password')}
          placeholder={t('common.current_password_placeholder')}
          value={currentPassword}
          onChange={(e) => { setCurrentPassword(e.target.value); clearError(); }}
          type="password"
        />
        <TextBox
          label={t('common.current_password_confirm_label')}
          placeholder={t('common.current_password_confirm_placeholder')}
          value={currentPasswordConfirm}
          onChange={(e) => { setCurrentPasswordConfirm(e.target.value); clearError(); }}
          type="password"
        />
        <TextBox
          label={t('common.new_password')}
          placeholder={t('common.new_password_placeholder')}
          value={newPassword}
          onChange={(e) => { setNewPassword(e.target.value); clearError(); }}
          type="password"
        />
      </div>

      {error && (
        <p className="text-sm text-mono-500 text-center leading-relaxed break-keep">
          {t('common.password_mismatch_check')}
        </p>
      )}

      <div className="flex gap-3">
        <Button level="level3" fullWidth onClick={onClose}>{t('common.cancel')}</Button>
        <Button level="level1" fullWidth onClick={handleSubmit} disabled={!currentPassword || !currentPasswordConfirm || !newPassword || submitting}>{submitting ? t('common.changing') : t('common.confirm')}</Button>
      </div>
    </ModalWrapper>
  );
}
